//参考 https://github.com/ElemeFE/element/blob/dev/src/index.js
import Tips from '@/module/tips/1.0.0/main.js'

const components = [
    Tips
];

const install = function(Vue) {
    components.forEach(component => {
      Vue.component(component.name, component);
    });
  
    Vue.prototype.$tips = Tips;
  
};

/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
}

export default {
      install,
      Tips
}